import { IAPIProxy, getAPIProxy } from '@inwink/apibase';
import getCookieAPIProxy from '@@api/apiproxy';
import { userPreferences } from '@@api/base/userPreferences';
import { communityEntityViewDataSource } from '../../admin/api/communityentityview';
import { IDataSourceV3Options, IDataSourceV3, getEntityDataSource } from '@@api/base/datasource';
import { fileInputManager } from '@@api/base/fileinputmanager';

let _communityAPIProxy: IAPIProxy = null;

export const getCommunityAPIProxy = () => {
    if (!_communityAPIProxy) {
        _communityAPIProxy = inwink.config.clientConfig.authMode === 'cookies'
            ? getCookieAPIProxy(inwink.config.communityApiUrl)
            : getAPIProxy(inwink.config.communityApiUrl);
    }

    return _communityAPIProxy;
};

export function getCommunityEntityDataSource<T>(
    communityId: string,
    entityRoute: string,
    entityName: string,
    options?: IDataSourceV3Options
): IDataSourceV3<T> {
    const proxy = getCommunityAPIProxy();
    const userPreferencesDatasource = communityEntityViewDataSource(communityId);
    const userpreferencesProvider = userPreferences(userPreferencesDatasource, entityName);
    return getEntityDataSource<T>(proxy, communityId + "/", entityRoute, entityName, userpreferencesProvider, options);
}

export function communityFileInputManager(communityid: string, fileUrlBuilder: (entity: string) => string = null) {
    const proxy = getCommunityAPIProxy();
    return fileInputManager(communityid, proxy, fileUrlBuilder);
}